import { createAction } from '@'
import FetchMappingCoverage, { notifyWrite } from './FetchMappingCoverage'
import GetHotelCoverage from './GetHotelCoverage'
import { $hotelCoverageQuery } from '../stores'

const describeChanges = (changes = {}) => {
    const parts = []
    if (changes.provider_rows) {
        parts.push('provider row updated')
    }
    if (changes.regions_added) {
        parts.push(`${changes.regions_added} region link(s) added`)
    }
    if (changes.regions_removed) {
        parts.push(`${changes.regions_removed} region link(s) removed`)
    }
    return parts.join(', ') || 'nothing changed'
}

export default createAction('UpdateHotel', async (hotelId, body) => {
    const data = await FetchMappingCoverage({
        method: 'PUT',
        path: `/hotel/${encodeURIComponent(hotelId)}`,
        data: body
    })
    notifyWrite(`Hotel ${hotelId}: ${describeChanges(data.changes)}`, data)
    const query = $hotelCoverageQuery.getState()
    if (query) {
        await GetHotelCoverage(query)
    }
    return data
})
